export type WxbCssToken = `--wx-${string}`;

export const readWxbToken = (token: WxbCssToken): string => {
  if (typeof window === 'undefined' || !window.document) {
    return `var(${token})`;
  }

  const value = window.getComputedStyle(window.document.documentElement).getPropertyValue(token).trim();
  return value || `var(${token})`;
};

export const readWxbTokens = (tokens: WxbCssToken[]): string[] => tokens.map(readWxbToken);
